import { Button, DateTime, FieldLabel, ModalPanel, Title } from "dash-styled"
import { FC, useMemo, useState } from "react"

interface ExtendTrialModalProps {
    isProcessing: boolean
    createdDate: string
    onClose: () => void
    onSubmit: (trialDays: number) => void
    currentTrialDays: number
}

export const ExtendTrialModal: FC<ExtendTrialModalProps> = ({
    currentTrialDays,
    isProcessing,
    createdDate,
    onClose,
    onSubmit
}) => {
    const [created, currentExpiryDate] = useMemo(() => {
        const created = new Date(createdDate)
        const expiryDate = new Date(created)
        expiryDate.setDate(expiryDate.getDate() + currentTrialDays)
        return [created, expiryDate]
    }, [createdDate, currentTrialDays])

    const [selectedDate, setSelectedDate] = useState<string | undefined>(
        currentExpiryDate.toISOString()
    )

    const newTrialDays: number = useMemo<number>(() => {
        const newTrialDate = new Date(selectedDate ?? created)
        return Math.ceil(
            (newTrialDate.getTime() - created.getTime()) / (1000 * 3600 * 24)
        )
    }, [created, selectedDate])

    const handleSubmit = () => onSubmit(newTrialDays)

    return (
        <ModalPanel
            onClose={onClose}
            className="max-w-2xl w-full"
            testId="extend-trial-modal"
        >
            <Title variant="heading2" weight="semibold">
                Extend trial days
            </Title>
            <FieldLabel label="Extend trial until:" />
            <DateTime
                className="flex-grow"
                value={selectedDate}
                dateFormat="dd.MM.yyyy"
                inputClassName="shadow-none"
                minDate={created}
                showTimeInput={false}
                onChange={setSelectedDate}
            />
            <div className="flex justify-center pt-4">
                <Button
                    testId="extend-trial-submit"
                    className="w-auto"
                    disabled={
                        isProcessing ||
                        selectedDate === undefined ||
                        currentTrialDays === newTrialDays
                    }
                    onClick={handleSubmit}
                >
                    {isProcessing ? "Updating..." : "Update"}
                </Button>
            </div>
        </ModalPanel>
    )
}
